export enum GlobalMyAccountFinHubRoutes {
  BASE = 'myaccount-financialhub',
  ORDERS = 'orders',
  QUOTES = 'quotes',
  CONSOPASS_REPORTING = 'consopass-reporting'
}
